export default __webpack_public_path__ + "static/media/blood-sugar-icon.b7eb55c6.svg";